import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import scan from "../../assets/module-2/2-2-6-scan.png";
import LdsImage from "../../components/LdsImage";
import FigureCaption from "../../components/LdsFigureCaption";
import References from "../../components/References";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.2.6 Example of a Positive Scan
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row mt-5 mb-4 justify-content-center">
            <div className="col-lg-6 col-10">
              <FigureCaption
                noCollapse={true}
                className="figcaption-no-border align-items-center flex-column d-flex"
                radiusSize="small"
                textContent={
                  <>
                    <p className="gray">
                      &copy;2016. Avid Radiopharmaceuticals, Inc. All rights reserved. Data on file, Lilly Research Laboratories: AMY20121001B.
                    </p>
                  </>
                }
              >
                <LdsImage
                  src={scan}
                  alt="A brain scan image labeled as positive, indicating the presence of amyloid plaques."
                />
              </FigureCaption>
            </div>
          </section>

          <section className="row mb-4 justify-content-center">
            <div className="col-12 col-lg-8">
              <ul className="ms-0">
                <li>
                  A positive Amyvid scan indicates the presence of moderate to
                  frequent amyloid neuritic plaques and is consistent with a
                  neuropathological diagnosis of AD
                  <ul className="ms-0">
                    <li>
                      This amount of amyloid plaque is seen in patients with AD
                      but may also be present in patients with other conditions,
                      as well as cognitively normal older people
                    </li>
                  </ul>
                </li>

                <li>
                  A positive Amyvid scan does not establish a diagnosis of AD or
                  other cognitive disorder
                </li>
                <li>The objective of Amyvid image interpretation is to provide an estimate of the brain beta-amyloid neuritic plaque density, not to make a clinical diagnosis. Image interpretation is performed independently of a patient’s clinical features and relies upon the recognition of unique image features</li>
              </ul>
              <h5 className="b text-uppercase mb-3 mt-3">Select Important Safety Information</h5>
              <p><strong>Risk for Image Misinterpretation and Other Errors</strong></p>
              <p>Errors may occur during Amyvid image interpretation. Image interpretation should be performed independently of the patient's clinical information. Amyvid scan results are indicative of plaque content only at the time of image acquisition and a negative scan does not preclude the development of brain amyloid in the future.</p>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-5", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-7", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <p className="fz-sm gray">
              Amyvid (florbetapir F 18 injection). Prescribing Information. Lilly USA, LLC.
            </p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
